module.exports = __webpack_public_path__ + "static/media/11ActualizacionDatosEmpresa-11.77fc9db1.png";